module.exports = __webpack_public_path__ + "static/assets/bf2e5bd090012d68560b888d44678efc.svg";